module.exports =
  '_FRIEND':
    "TITLE": "Friends"
    "NAME": "Name"
    "EMAIL": "Email Address"
    "ENTER_NEW_FRIEND": "Enter New Friend"
    "ENTER_EMAIL": "Enter Email"
    "HDCP_INVALID": "This HDCP value is invalid"



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/friend/i18n/en.coffee